import React from 'react';
import { ScoreEvaluationPage01 } from './layout_01/ScoreEvaluationLayout';
import { ScoreEvaluationPage02 } from './layout_02/ScoreEvaluationLayout';
import { useAppSelector } from '../../redux-store/hook';
import { getTemplateLayout } from '../../common/utils/fallbackCondition';

const ScoreEvaluationPageLayoutMap: { [key: string]: React.FC } = {
  TEMPLATE_LAYOUT_01: ScoreEvaluationPage01,
  TEMPLATE_LAYOUT_02: ScoreEvaluationPage02,
};

export const ScoreEvaluationPage = (): JSX.Element => {
  const template = useAppSelector((state) => state.template);
  const { layoutCode } = template;
  const layout = getTemplateLayout(layoutCode);
  const ScoreEvaluationPage = ScoreEvaluationPageLayoutMap[layout];
  return <ScoreEvaluationPage />;
};
